import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 500px;
    height: 56px;

    .search {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 280px;
        height: 56px;
        padding: 16px;
        background: ${({ theme }) => theme.colors.interfacePure0};
        border-radius: 8px;
        input {
            width: 205px;
            border: none;
            outline: none;
        }

        .buscar {
            cursor: pointer;
        }

        .clean-search {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.interfaceText300};
                }
                &:hover {
                    cursor: pointer;
                    path {
                        fill: ${({ theme }) => theme.colors.interfaceText500};
                    }
                }
            }
        }
    }
`

